module.exports = __webpack_public_path__ + "media/images/lp_right-blue-fd148361781b1737d3910b9f114f81eb.webp";